// extracted by mini-css-extract-plugin
export default {"layout":"_1xQ_d___App-module__layout","header":"CUxdD___App-module__header","breadcrumbsContainer":"_2CDtZ___App-module__breadcrumbsContainer"};